import type { ElementType, ReactElement, ReactNode } from "react";
import { isValidElement } from "react";

type StyledTypeMeta = {
  displayName?: string;
  __wyw_meta?: { className?: string };
};

function isSameStyledTypeDev(actual: unknown, expected: ElementType): boolean {
  const actualMeta = actual as StyledTypeMeta;
  const expectedMeta = expected as StyledTypeMeta;

  const actualClass = actualMeta.__wyw_meta?.className;
  const expectedClass = expectedMeta.__wyw_meta?.className;
  if (actualClass && expectedClass && actualClass === expectedClass) {
    return true;
  }

  const actualName = actualMeta.displayName;
  const expectedName = expectedMeta.displayName;
  if (actualName && expectedName && actualName === expectedName) {
    return true;
  }

  return false;
}

export function isSameComponentType(
  actual: unknown,
  expected: ElementType,
): boolean {
  if (actual === expected) {
    return true;
  }
  if (import.meta.env.DEV) {
    return isSameStyledTypeDev(actual, expected);
  }
  return false;
}

export function isElementOfType(
  node: ReactNode,
  component: ElementType | ElementType[],
): node is ReactElement {
  if (!isValidElement(node)) {
    return false;
  }
  const expected = Array.isArray(component) ? component : [component];
  return expected.some((type) => isSameComponentType(node.type, type));
}
